module.exports = __webpack_public_path__ + "img/lsjc_2.1b4df0ae.png";